import { MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import "react-datepicker/dist/react-datepicker.css";
import globalUseStyles from '../../styles/globalCustomStyles';

const ChooseCentileButton = (props) => {
    const t = useTranslate();
    const globalClasses = globalUseStyles();
    const centile = props.centile;
    const setCentile = props.setCentile;

    return (
        <div className={globalClasses.centileSelectContainer}>
            <Typography variant="h9" style={{ marginRight: '10px' }}>{t('resources.global.chooseCentileTitle')}</Typography>
            <div className={globalClasses.centileSelect}>
                <Select
                    value={centile}
                    onChange={(event) => setCentile(event.target.value)}
                    className={globalClasses.centileSelect}
                >
                    {[...Array(11).keys()].map((i) => {
                        return <MenuItem key={i} value={i / 10} className={globalClasses.centileSelect}>{i / 10}</MenuItem>
                    })}
                </Select>
            </div>
        </div>
    );
}

export default ChooseCentileButton;